angular.module('zc.zenclerkS')
  .controller('ZcsFreeShippingCostEditorController', ZcsFreeShippingCostEditorController);

ZcsFreeShippingCostEditorController.$inject = ['$scope', '$uibModalInstance', 'ZcsProject', 'currencies', 'project'];
function ZcsFreeShippingCostEditorController($scope, $uibModalInstance, ZcsProject, currencies, project) {
  const vm = this;
  vm.project = project;
  vm.close = close;
  vm.setFreeShippingCost = setFreeShippingCost;
  vm.isSaving = false;
  // store temporarily first
  vm.freeShippingCost = vm.project.free_shipping_cost;
  vm.currency = currencies[vm.project.currency];

  function setFreeShippingCost() {
    vm.isSaving = true;
    const newProject = _.merge({}, vm.project, {free_shipping_cost: vm.freeShippingCost});
    ZcsProject.saveProject(newProject).then(res => {
      vm.project = _.merge(vm.project, res);
    })
      .finally(() => {
        vm.isSaving = false;
        $scope.setFreeShippingCost.$setPristine();
        close();
      });
  }

  function close() {
    $uibModalInstance.close();
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/project/free_shipping_cost_editor/free_shipping_cost_editor.controller.js